document.addEventListener("DOMContentLoaded", () => {
  console.log("JS Loaded");

  const btn = document.getElementById("lavizahMenuBtn");
  const menu = document.getElementById("lavizahMobileMenu");
  const overlay = document.getElementById("lavizahOverlay");
  const close = document.getElementById("lavizahClose");

  console.log(btn, menu, overlay, close);

  if (btn) {
    btn.addEventListener("click", () => {
      console.log("Menu clicked");
      menu.classList.add("active");
      overlay.classList.add("active");
    });
  }

  if (close) {
    close.addEventListener("click", () => {
      menu.classList.remove("active");
      overlay.classList.remove("active");
    });
  }

  if (overlay) {
    overlay.addEventListener("click", () => {
      menu.classList.remove("active");
      overlay.classList.remove("active");
    });
  }
});


